import axiosInstance from '../utils/axios';
import { TransactionOwnershipType } from "../@types/transactions";

const EXTEND_URL = '/data-export';
const IMPORT_URL = '/data-import/bulk-flight-upload/v1';

export type GetPurchasesQueryParams = {
  ownershipType: TransactionOwnershipType | TransactionOwnershipType[],
  merchantCode: string | undefined,
  page: number,
  size: number,
  dateFrom?: string,
  dateTo?: string,
  email?: string,
  fields?: string[]
}

function exportPurchases(params: GetPurchasesQueryParams) {
  return axiosInstance.get(
    `${EXTEND_URL}/purchases/v1/`,
    { params, responseType: 'blob', paramsSerializer: { indexes: null } }
  );
}

export type GetCustomersQueryParams = {
  merchantCode: string,
  programmeCode: string
  dateFrom?: string,
  dateTo?: string,
  emailAddress?: string,
  fields?: string[]
}

function exportCustomers(params: GetCustomersQueryParams) {
  return axiosInstance.get(
    `${EXTEND_URL}/customers/v1/`,
    { params, responseType: 'blob', paramsSerializer: { indexes: null } }
  );
}

export type ImportBulkTravelFilePayload = {
  defaultEmail: string;
  templateType: string;
  emissionRecordId: string;
  merchantCode: string;
  skipErrors: boolean;
  file: File;
}

async function importBulkTravelFile(payload: ImportBulkTravelFilePayload) {
  const { defaultEmail, templateType, emissionRecordId, merchantCode, skipErrors, file } = payload;
  const formData = new FormData();

  formData.append('file', file);

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };

  return axiosInstance.post(
    `${IMPORT_URL}/?defaultEmail=${defaultEmail}&templateType=${templateType}&emissionRecordId=${emissionRecordId}&merchantCode=${merchantCode}&skipErrors=${skipErrors}`,
    formData,
    config
  );
}

export {
  exportPurchases, exportCustomers, importBulkTravelFile
};
